import { render, staticRenderFns } from "./headerComponent.vue?vue&type=template&id=137ec6b3&scoped=true&"
import script from "./headerComponent.vue?vue&type=script&lang=js&"
export * from "./headerComponent.vue?vue&type=script&lang=js&"
import style0 from "./headerComponent.vue?vue&type=style&index=0&id=137ec6b3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137ec6b3",
  null
  
)

export default component.exports